import { render, staticRenderFns } from "./PausedLeadsListItem.vue?vue&type=template&id=2475aaa3&scoped=true"
import script from "./PausedLeadsListItem.vue?vue&type=script&lang=js"
export * from "./PausedLeadsListItem.vue?vue&type=script&lang=js"
import style0 from "./PausedLeadsListItem.vue?vue&type=style&index=0&id=2475aaa3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2475aaa3",
  null
  
)

export default component.exports